class RigidBodyComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { RigidBodyComponentData };
